import { ADD_ITEMS } from 'Actions/myzone';
import actionConstants from 'Actions/constants';

const transformResponse = compactAds => {
    return compactAds.map(compactAd => {
        const {
            compactAdData: { data },
            compactPriceData,
            reserveData
        } = compactAd;
        const {
            id,
            sellerId,
            categoryId,
            imageUrl,
            status: { status },
            parameters,
            price,
            hasPhoneparam,
            ...rest
        } = data;

        return {
            ...compactPriceData,
            id,
            user_id: sellerId,
            category_id: categoryId,
            has_phone_number: hasPhoneparam,
            imageUrl,
            status,
            parameters,
            price,
            reserveData,
            ...rest
        };
    });
};

export const initialState = {
    adsData: {},
    isFetching: false,
    isError: false,
    isSuccess: false,
    batchIndex: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'MY_ZONE_SET_BATCH_INDEX': {
            return {
                ...state,
                batchIndex: action.data
            };
        }

        case 'MY_ZONE_SET_QUICK_FILTERS': {
            return {
                ...state,
                quickFilters: action.data
            };
        }

        case `RESPONSE_POST_${ADD_ITEMS}`: {
            const {
                data: {
                    data: { nAdsDetailById }
                }
            } = action;
            const transformedData = transformResponse(
                nAdsDetailById.compactAds
            );
            const adsNewItemCopy = { ...state.adsData };

            transformedData.forEach(data => {
                adsNewItemCopy[data.id] = data;
            });

            return {
                ...state,
                isFetching: false,
                isError: false,
                adsData: adsNewItemCopy
            };
        }

        case `REQUEST_${ADD_ITEMS}`:
            return { ...state, isFetching: true };

        case `ERROR_POST_${ADD_ITEMS}`:
            return { ...state, isFetching: false, error: true };

        case `CUSTOM_RECEIVE_${actionConstants.CAR_RESERVE_STATUS}`:
            return {
                ...state,
                adsData: {
                    ...state.adsData,
                    ...(state.adsData[action.adId] ? { [action.adId]: {
                        ...state.adsData[action.adId],
                        reserveData: {
                            status: action?.data?.car?.status,
                            expiryDate: action?.data?.car?.reservationExpiry,
                            isReservedByCurrentUser: action?.data?.isReservedByCurrentUser,
                            hasReservedAnyCar: action?.data?.user?.hasReservedAnyCar
                        }
                    }} : {})
                }
            };

        default:
            return state || null;
    }
};
